<div class="login-container" [ngClass]="{'dark-theme': (themeService.currentTheme$ | async) === 'dark'}">
  <div class="login-card">
    <div class="login-header">
      <img src="assets/images/innovadoc-logo.png" alt="Innovadoc IA" class="login-logo">
      <h1 class="login-title">Innovadoc IA</h1>
    </div>

    <div class="login-body">
      <div *ngIf="errorMessage" class="alert alert-danger">
        {{ errorMessage }}
      </div>

      <div class="login-buttons">
        <button class="btn btn-primary btn-lg btn-block" (click)="login()" [disabled]="isLoading">
          <i class="fas fa-sign-in-alt me-2"></i>
          {{ translate('auth.login') }}
        </button>

        <div class="login-divider">
          <span>{{ translate('auth.or') }}</span>
        </div>

        <button class="btn btn-outline-primary btn-lg btn-block" (click)="signup()" [disabled]="isLoading">
          <i class="fas fa-user-plus me-2"></i>
          {{ translate('auth.signup') }}
        </button>
      </div>

      <div class="login-loading" *ngIf="isLoading">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ translate('auth.loading') }}</span>
        </div>
        <p>{{ translate('auth.redirecting') }}</p>
      </div>
    </div>

    <div class="login-footer">
      <p>{{ translate('auth.powered_by') }} <strong>Innovadoc IA</strong></p>
      <div class="login-language-select">
        <select class="form-select form-select-sm" [ngModel]="languageService.getCurrentLang()" (ngModelChange)="languageService.setLanguage($event)" id="login-language-select">
          <option value="es">Español</option>
          <option value="en">English</option>
          <option value="pt">Português</option>
          <option value="fr">Français</option>
          <option value="ja">日本語</option>
        </select>
      </div>
    </div>
  </div>
</div>